import acro from "./images/alice-naar-c_c5hd-9iwY-unsplash.jpg";
import castle_2 from "./images/artem-sapegin-XGDBdSQ70O0-unsplash.jpg";
import cottage from "./images/thomas-claeys-SrbXjbo-XbQ-unsplash.jpg";
import performances from "./images/tim-gouw-tYpp-eIZH44-unsplash.jpg";

const data = [
    {
        "showHeading": "Tranquility",
        "link": "/Tranquility",
        "previewHeading": "Tranquility 2020 - 2021",
        "showDescription": [
            {
                "type": "paragraph",
                "text": "Tranquility is an open air interactive performance."
            },
            {
                "type": "paragraph",
                "text": "30min solo pice by Dancer Sophy Hastings, followed by a 15min meditative relaxation."
            },
            {
                "type": "paragraph",
                "text": "Sophy Hastings is currently preforming Tranquility in Key west, Key Largo and Miami. She created the pice because she felt that the citizen in her home Bahama Villa needed a moment of escape from the currant world situation."
            },
            {
                "type": "blockquote",
                "text": "“Inner calm and trust in life is my biggest survival tool in any trying life circumstances. This is a state that I have learned to arrive at during my visits in the Temples in India. I wish to inspire and encourage others to to find this state, this is why I created the pice Tranquility”"
            },
            {
                "type": "source",
                "text": "New York times May 2020"
            },
            {
                "type": "h4",
                "text": "Meditation to tranquil music"
            },
            {
                "type": "paragraph",
                "text": "Sophy has composed meditative songs that she sings live accompanied by musician Mathew Carrings creating an ambient atmosphere with hang drums. The audience is invited to sit and meditate or to lay down on their yoga mats and relax."
            }
        ],
        "image": acro
    },
    {
        "showHeading": "Mystic Paradise",
        "link": "/MysticParadise",
        "previewHeading": "Mystic Paradise 2021",
        "showDescription": [
            {
                "type": "blockquote",
                "text": "“A true performance spectacle including air acrobatics”"
            },
            {
                "type": "source",
                "text": "Josefine Hariss Times Magasine"
            },{
                "type": "paragraph",
                "text": "This year you will find our stage transformed into a mystical space in nature. World famous gardener Alexandro Gonzales has designed the set with live trees and plants. The biggest challengen for the set design is the massive body of water that is on stage through out the performance."
            },
            
          
            {
                "type": "blockquote",
                "text": ' "Welcome to Mysstic Grove, here you can be who you truly are." '
            },
            {
                "type": "source",
                "text": "Gabriel the angel gate Gurdian"
            },
           {
                "type": "paragraph",
                "text": "A newly written fantasy musical for the whole family. World famous Andrew With has composed mesmerising melodies and lyrics for hand selected singer from around the globe. This years leading role will be played by Australias star Whitney Andrews."
            }
        ],
        "image": castle_2
    },
    {
        "showHeading": "Cottage county",
        "link": "/CottageCounty",
        "previewHeading": "Cottage county 2021 - 2022",
        "showDescription": [
            {
                "type": "paragraph",
                "text": "Cottage County tells the story of the community spirit in Mystic grove. In 1845 the town experiences grate tragedy as the catastrophe 24 occurred and over half of the village was killed. Children where left with out parents and couples lost their spouses. Great sorrow came over the village. Martha Harris an elderly woman with no family, coordinated accommodation and food for those who had become homeless over night."
            },
            {
                "type": "h4",
                "text": "“Our country is starving, we need to feed them”"
            },
            {
                "type": "paragraph",
                "text": "Legend has it that Martha Harris walked into the house of parliament and said “ Our country is starving, we need to feed them, find me the biggest kitchen you can and I will make the people dinners Mondays -Saturdays, on Sunday I will rest. ”She then coordinated food supplying from farmers from around the country. She lifted the spirits of the citizens as she supplied them with the food and shelter that they needed in thees trying times. Now her grate great great grand daughter has made this historic event into a Play to honer the women know today as “Mother of the Town” as she was there for hundreds of people in need. This is our yearly Musical for 2021. As always the it is a world premier."
            }
        ],
        "image": cottage
    },
    {
        "showHeading": "Northern Rythem",
        "link": "/NorthernRythem",
        "previewHeading": "Northern Rythem 2022 - 2023",
        "showDescription": [
            {
                "type": "paragraph",
                "text": "Playwright Harry Austin has spent 2 years travelling in Northern Europe. He has gotten to know the locals and researched the the culture of the different countries. Harry has visited folk dance communities as well as folk song communities in Ireland, Scotland, Island, Sweden and Finland. Based on his research he has written a play incorporating the different songs and dances. Director Adriana Sigridsdottir has then traveled to thees countries for rehearsals with the local theatres, practising fragments of the show."
            },
            {
                "type": "h4",
                "text": "International colaboration"
            },
            {
                "type": "paragraph",
                "text": "The Performers for this production are based in Ireland, Scotland, Island, Sweden and Finland. The theatres are rehearsing individually and will then come together to tour these countries in summer 2021, ending their tour in or home bace in New York September 2021."
            }
        ],
        "image": performances
    }     
]

export default data;